import { Component, h, VNodeChild } from "vue"
import { RouterLink } from "vue-router"
import { MenuOption, NIcon } from "naive-ui"

const getLabel = (label?: string | (() => VNodeChild)) => {
  if(typeof label === "function") return label()

  return label
}

export const navRouterLink = (
  name: string,
  label?: string | (() => VNodeChild),
  options?: { icon?: VNodeChild, style?: string }
) => {
  const item: MenuOption = {
    label: () => h(
      RouterLink,
      {
        to: { name },
        style: options?.style || ""
      },
      { default: () => getLabel(label) }
    ),
    key: name
  }

  if(options?.icon) {
    item.icon = () => options.icon
  }

  return item
}

export const renderIcon = (icon: Component, params: Record<string, unknown> | null = null) =>
  () => h(NIcon, params, { default: () => h(icon) })
